module.exports = __webpack_public_path__ + "static/media/P15.12b9247a.jpg";